import $ from 'jquery'

import AnchorLink from './modules/anchorLink'
import Faq from './modules/faq'
import Header from './modules/header'
import Listing from './modules/listing'
import Lnavi from './modules/lnavi'
import MatchHeight from './modules/match_height'
import MenuScroll from './modules/menuScroll'
import Pagetop from './modules/pagetop'
import Screen from './modules/screen'
import Sidebar from './modules/sidebar'
import Sort from './modules/sort'
import Format from './modules/format'

/* ----------------------------------------------------------
  init
---------------------------------------------------------- */
const anchorLink = new AnchorLink({
  target: '.js-anchor'
})

const matchHeight = new MatchHeight({
  target: '.js-matchHeightGroup'
})

const pagetop = new Pagetop({
  target: '.js-pagetop'
})

const faq = new Faq()

const header = new Header()

const listing = new Listing()

const lnavi = new Lnavi()

const menuScroll = new MenuScroll()

const sidebar = new Sidebar()

const sort = new Sort()

const format = new Format()

anchorLink.init()
faq.init()
header.init()
listing.init()
lnavi.init()
matchHeight.init()
menuScroll.init()
pagetop.init()
sidebar.init()
sort.init()
format.init()

/* ----------------------------------------------------------
  Screen
---------------------------------------------------------- */
const screen = new Screen()
$(window).on('resize', screen.size())
$(window).on('breakpointChange')
